import * as React from 'react'
function SvgUpload2(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 24a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 114 0v6h24v-6a2 2 0 012-2zM20 8a2 2 0 012 2v4h4a2 2 0 110 4h-4v4a2 2 0 11-4 0v-4h-4a2 2 0 110-4h4v-4a2 2 0 012-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgUpload2
